import { proxy } from "valtio";

export type WSMessageEvent = "system" | "resource" | "notification";
export type WSMessage = {
  accountID: string;
  "X-Account-Hash": string;
  event: WSMessageEvent;
  data: any;
};

type WebsocketStore = {
  websocket: {
    sendJsonMessage: (wsmsg: WSMessage) => void;
    lastJsonMessage: WSMessage;
  };
};

const WSStore = proxy<WebsocketStore>({
  websocket: null as any,
});

export default WSStore;
